import { Species } from './Species.model';
import { Pet } from './Pet.model';
import { User } from './User.model';
import { ContactInfo } from './User.model';

export class Account {
    //constructor() { }
    type; // owner shelter
    Owner;  // undefined it
    Shelter; //undefined
    User;
    ContactInfo;
}

//export default Account;